import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import metadata from './MLPaymentLogAdditionalFilter.metadata.json5';
import messages from './MLPaymentLogAdditionalFilter.messages';

const MLPaymentLogAdditionalFilter = (props) => {
    const {
        filterData,
        updateFilterData
    } = props;
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();

    const paymentMethodAvailableValues = [
        {
            code: translator(messages.creditDebitCardCode),
            name: translator(messages.creditDebitCard)
        },
        {
            code: translator(messages.bankAccountCode),
            name: translator(messages.bankAccount)
        },
        {
            code: translator(messages.agencySweepCode),
            name: translator(messages.agencySweep)
        }
    ];

    const onValueChange = (value, path) => {
        _.set(filterData, path, value);
        updateFilterData(filterData);
        refreshData();
    }

    const overrideProps = {
        paymentMethod: {
            availableValues: paymentMethodAvailableValues
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={filterData}
            onValueChange={onValueChange}
        />
    );
};

MLPaymentLogAdditionalFilter.propTypes = {
    filterData: PropTypes.shape({}).isRequired,
    updateFilterData: PropTypes.func.isRequired,
};

export default MLPaymentLogAdditionalFilter;
